import React, { useContext } from 'react'
import { DeleteFilled, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { notification, Popconfirm } from 'antd'
import { Link, useHistory } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import styled from 'styled-components'
import { THEME } from 'Util/constants'
import { SOFT_DELETE_LOCATION_GROUP } from 'Util/mutations'
import { LocationGroupsContext } from '..'
import ExtraFilters from './ExtraFilters'

const Container = styled.div`
    border: solid 1px #ccc;
    padding: 10px 15px;
    margin: 10px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const Title = styled.div`
    font-weight: bold;
`

const MenuButtonContainer = styled.div`
    cursor: pointer;
    .anticon {
        color: ${THEME.colors.primary};
        margin-right: 5px;
    }
    label {
        font-weight: bold;
        cursor: pointer;
    }
`

const Disabled = styled.span`
    opacity: 0.4;
    cursor: not-allowed;
    .anticon { color: #888; }
`

function TableFilters(props) {
    const history = useHistory()
    const { selectedRecord, setSelectedRecord } = useContext(LocationGroupsContext)
    const hasSelection = !!selectedRecord?.id

    const [softDelete] = useMutation(SOFT_DELETE_LOCATION_GROUP, {
        onCompleted() {
            notification.success({ message: 'Deleted!', description: 'Location group deleted.' })
            setSelectedRecord({})
        },
        onError(err) {
            notification.error({ message: 'Delete failed', description: err.message })
        },
    })

    const handleEdit = () => {
        if (!hasSelection) return
        history.push(`/procurement/auction/groups/edit/${selectedRecord.id}`)
    }

    const handleDelete = () => {
        if (!hasSelection) return
        softDelete({ variables: { id: selectedRecord.id } })
    }

    return (
        <Container>
            <Title>Location Groups</Title>

            <MenuButtonContainer>
                <Link to='/procurement/auction/groups/new'><PlusOutlined /></Link>
                <label>New</label>
            </MenuButtonContainer>

            <MenuButtonContainer>
                {hasSelection ? (
                    <span onClick={handleEdit}>
                        <EditOutlined /> <label>Edit</label>
                    </span>
                ) : (
                    <Disabled><EditOutlined /> <label>Edit</label></Disabled>
                )}
            </MenuButtonContainer>

            <MenuButtonContainer>
                {hasSelection ? (
                    <Popconfirm
                        title={`Delete group "${selectedRecord.label}"?`}
                        onConfirm={handleDelete}
                        okText='Yes'
                        cancelText='No'
                        okButtonProps={{ danger: true }}
                    >
                        <DeleteFilled /> <label>Delete</label>
                    </Popconfirm>
                ) : (
                    <Disabled><DeleteFilled /> <label>Delete</label></Disabled>
                )}
            </MenuButtonContainer>

            <ExtraFilters data={props.data} columns={props.columns} />
        </Container>
    )
}

export default TableFilters
